<script setup lang="ts">
  import { computed, useAttrs } from "vue";
  import type { HTMLAttributes } from "vue";
  import { AlertDialogAction, type AlertDialogActionProps } from "reka-ui";
  import { cn } from "@/lib/utils";
  import { buttonVariants } from "@/components/ui/button";

  const props = defineProps<AlertDialogActionProps & { class?: HTMLAttributes["class"] }>();
  const emit = defineEmits(["click"]);
  const attrs = useAttrs();
  const forwarded = computed(() => ({ ...props, ...attrs }));
</script>

<template>
  <AlertDialogAction
    v-bind="forwarded"
    :class="cn(buttonVariants(), props.class)"
    @click="emit('click', $event)">
    <slot />
  </AlertDialogAction>
</template>
